export enum Error {
  INCORRECT_VALUE,
  ORDER_NOT_QUARTERBACKABLE,
  PICKUP_ADDRESS_NOT_FOUND,
  ORDER_NOT_FOUND,
  QRCODE_NOT_VALID,
  WRONG_STORAGE_REF,
  TRANSPORTSHEET_ALREADY_FACTORYRECEIVED,
  TRANSPORTSHEET_WITHOUT_USERID,
  TRANSPORTSHEET_IS_FACTORYTOCLIENT,
}

export const ErrorMap = new Map([
  [Error.INCORRECT_VALUE, ``],
  [Error.ORDER_NOT_QUARTERBACKABLE, `Commande non quarterbackable`],
  [Error.PICKUP_ADDRESS_NOT_FOUND, `Aucune de vos adresses ne correspond à celle de l'enlèvement`],
  [Error.ORDER_NOT_FOUND, `Commande non trouvée.`],
  [Error.QRCODE_NOT_VALID, `QRCode non valide`],
  [Error.WRONG_STORAGE_REF, `Erreur emplacement`],
  [Error.TRANSPORTSHEET_ALREADY_FACTORYRECEIVED, `Étiquette déjà réceptionnée`],
  [Error.TRANSPORTSHEET_WITHOUT_USERID, `Étiquette non rattachée`],
  [Error.TRANSPORTSHEET_IS_FACTORYTOCLIENT, `Étiquette colis retour`],
]);
